import { render } from "./interview-questions.vue?vue&type=template&id=82755472"
import script from "./interview-questions.vue?vue&type=script&lang=js"
export * from "./interview-questions.vue?vue&type=script&lang=js"

import "./interview-questions.vue?vue&type=style&index=0&id=82755472&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__